var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotePencil1616 = function SvgNotePencil1616(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#565758",
    d: "M13.333 15.334H2.667c-.734 0-1.334-.6-1.334-1.333s.6-1.333 1.334-1.333h10.666c.734 0 1.334.6 1.334 1.333s-.6 1.333-1.334 1.333M8.707 2.794l2.5 2.5-5.847 5.847a.65.65 0 0 1-.467.193h-1.56a.67.67 0 0 1-.666-.666v-1.56c0-.18.073-.347.193-.474zm3.213 1.787-2.5-2.5L10.64.86c.26-.26.68-.26.94 0l1.56 1.56c.26.26.26.68 0 .94z"
  })));
};
export default SvgNotePencil1616;